module.exports = __webpack_public_path__ + "air_ico.png?dc9ccf78b3a6ff2495b979e178af94d7";